"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findFiscalYearsInPeriod = void 0;
const findFiscalYearsInPeriod = (fiscalYears, period) => {
    const fiscalYearsInPeriod = fiscalYears.filter((fiscalYear) => {
        const taxYearStartDate = new Date(fiscalYear.taxYearStartDate);
        const taxYearEndDate = new Date(fiscalYear.taxYearEndDate);
        const { endMonthYear, startMonthYear } = period;
        const periodStartDate = new Date(startMonthYear.year, startMonthYear.month, 1);
        const periodEndDate = new Date(endMonthYear.year, endMonthYear.month, 1);
        return (
        // fiscal year begins before the start of period and ends during or after the period
        (taxYearStartDate <= periodStartDate && periodStartDate <= taxYearEndDate) ||
            //   fiscal year begins during or before the period and ends after the period
            (taxYearStartDate <= periodEndDate && periodEndDate <= taxYearEndDate) ||
            //   fiscal year begins and ends within the period
            (periodStartDate <= taxYearStartDate && taxYearEndDate <= periodEndDate));
    });
    return fiscalYearsInPeriod;
};
exports.findFiscalYearsInPeriod = findFiscalYearsInPeriod;
